import SuspenseLayout from './SuspenseLayout';

export default SuspenseLayout;
